export default __webpack_public_path__ + "static/media/m_engineering_card14_2.98226aa6.png";